/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './import-dialog.scss';

/*@ngInject*/
export default function ImportDialogController($scope, $mdDialog, toast, fileType, importTitle, importFileLabel) {

    var vm = this;

    vm.$onInit = function () {
        vm.cancel = cancel;
        vm.importFile = importFile;
        vm.fileAdded = fileAdded;
        vm.clearFile = clearFile;

        vm.importTitle = importTitle;
        vm.importFileLabel = importFileLabel;

        vm.flowAttrs = {accept: '.' + fileType.extension + ',' + fileType.mimeType};
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function fileAdded($file) {
        if ($file.getExtension() === fileType.extension) {
            var reader = new FileReader();
            reader.onload = function(event) {
                $scope.$apply(function() {
                    if (event.target.result) {
                        $scope.theForm.$setDirty();
                        var data = event.target.result;
                        if (data && data.length > 0) {
                            vm.importData = data;
                            vm.fileName = $file.name;
                        }
                    }
                });
            };
            reader.readAsText($file.file);
        }
    }

    function clearFile() {
        $scope.theForm.$setDirty();
        vm.fileName = null;
        vm.importData = null;
    }

    function importFile() {
        $scope.theForm.$setPristine();
        $mdDialog.hide(vm.importData);
    }
}



// WEBPACK FOOTER //
// ./src/app/import-export/import-dialog.controller.js